import { BaseState } from '@/store/base-state';
import { TableOptions } from '@/types';
import { Orders } from '../../../types';

export default class OrdersInvoicesState extends BaseState {
  orders_invoices_list: Orders.OrdersInvoiceInfo[] = [];
  orders_invoices_allowed_dates: string[] = [];
  orders_invoices_organizations: string[] = [];
  users: Orders.UsersFilter[] = [];
  orders_invoices_loading = false;
  table_options: TableOptions = {
    ...this.create_table_opts,
    sortBy: [''],
    sortDesc: [true],
  };

  orders_invoices_filters: Orders.OrdersInvoicesFilters = {
    search: '', //
    date: '',
    organization: '',
    user_ids: [],
    only_has_unread_changes: false,
  };
}
